import React from "react";
import { Controller } from "react-hook-form";
import TextField_new from "../../mui/TextField_new";
import FormControl from "../../mui/FormControl";
import { styled } from "@mui/material";
import Typography from "../../mui/Typography";
import FormHelperText from "../../mui/FormHelperText";
import Stack from "../../mui/Stack";
import FormControlLabel from "../../mui/FormControlLabel";
import Radio from "../../mui/Radio";
import RadioGroup from "../../mui/RadioGroup";
import AutoComplete from "../../mui/AutoComplete";

const AwardAddForm = (props) => {
  const { control, formState ,operatorOptions} = props;



  return (
    <>
      <Controller
        name="awardName"
        control={control}
        rules={{ required: "Award name is required" }}
        render={({ field, fieldState: { error } }) => (
          <>
            <StyledTypography>Award Name</StyledTypography>
            <FormControl error={!!error} fullWidth>
              <TextField_new
                {...field}
                id="awardName"
                placeholder="Enter Award Name"
                error={!!error}
                autoFocus
                disabled={false}
              />
              <StyledFormHelperText>
                {error ? error.message : " "}
              </StyledFormHelperText>
            </FormControl>
          </>
        )}
      />

      <Controller
        name="points"
        control={control}
        rules={{
          required: "operator is required",
        }}
        render={({ field, fieldState: { error } }) => (
          <>
            <Typography>Points</Typography>
            <FormControl error={!!error} fullWidth>
              <AutoComplete
                {...field}
                id="operator-select"
                options={operatorOptions}
                matchKey="id"
                labelKey="label"
                placeholder="Select operator"
                disableClearable={false}
                onChange={(value) => field.onChange(value)} // Ensure value is set correctly
                // errorMsg={error?.message} // Pass the error message to AutoComplete
                loading={false}
                sx={{ backgroundColor: "#fff" }}
              />
              <StyledFormHelperText>
                {error ? error.message : " "}
              </StyledFormHelperText>
            </FormControl>
          </>
        )}
      />

      <Controller
        name="pointInPercentage"
        control={control}
        rules={{ required: "Points range is required" }}
        render={({ field, fieldState: { error } }) => (
          <>
            <StyledTypography>Enter point in %</StyledTypography>
            <FormControl error={!!error} fullWidth>
              <TextField_new
                {...field}
                id="pointInPercentage"
                placeholder="Enter point in %"
                error={!!error}
              />
              <StyledFormHelperText>
                {error ? error.message : " "}
              </StyledFormHelperText>
            </FormControl>
          </>
        )}
      />

      <Controller
        name="leaderBoardCount"
        control={control}
        rules={{ required: "Leader board count is required" }}
        render={({ field, fieldState: { error } }) => (
          <>
            <StyledTypography>Leader board count</StyledTypography>
            <FormControl error={!!error} fullWidth>
              <TextField_new
                {...field}
                id="leaderBoardCount"
                placeholder="Enter Leader board count"
                error={!!error}
                autoFocus
                disabled={false}
              />
              <StyledFormHelperText>
                {error ? error.message : " "}
              </StyledFormHelperText>
            </FormControl>
          </>
        )}
      />
    </>
  );
};

const StyledTypography = styled(Typography)(() => ({}));
const StyledFormHelperText = styled(FormHelperText)(() => ({
  // marginLeft: "0px",
  padding: "0",
}));

export default AwardAddForm;
